import { render, staticRenderFns } from "./IconCancel.vue?vue&type=template&id=68477908&"
import script from "./IconCancel.vue?vue&type=script&lang=js&"
export * from "./IconCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports